import React from "react";

const Form: React.FC<{ id: string }> = ({ id }) => (
  <div id={id} {...{ "data-name": "GlobalException" }}>
    <h2>Sorry, but we're having trouble signing you in.</h2>
    <div className="error-page-help">
      We track these errors automatically, but if the problem persists feel free
      to contact us. In the meantime, please try again.
    </div>
    <div className="error-page-messagedetails">
      <div className="error-page-correlationid">
        Correlation ID: c1514fe6-b7c3-421d-bc95-a15e14c2d05d
      </div>
      <div>Timestamp: 2020-12-21 17:07:06Z</div>
      <div className="error-page-detail">
        AADB2C99059: The supplied request must present a code_challenge
      </div>
    </div>
  </div>
);

export default Form;
